"use client";

import {
  Button as ChakraButton,
  type ButtonProps as ChakraButtonProps,
} from "@chakra-ui/react";
import { forwardRef } from "react";

export type ButtonProps = ChakraButtonProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ ...rest }, ref) {
    return (
      <ChakraButton
        ref={ref}
        _hover={{ color: "black", bg: "orange.600" }}
        {...rest}
      />
    );
  },
);
